import { useNavigate } from 'react-router-dom';
import { Button } from '@components/primitives/Button';
import { FeatureCard } from '@components/ui/cards/FeatureCard';
import { useEventTracking } from '@services/statsig';
import { publicAsset } from '@utils/publicAsset';

import CalendarIcon from '../../assets/admin-tools.svg?react';

import { CardImg } from './shared/CardImg';

/**
 * ScheduleAppointmentCard Component
 * Dashboard card for scheduling appointments with calendar icon
 */
export const ScheduleAppointmentCard = () => {
  const navigate = useNavigate();
  const { dashboard } = useEventTracking();

  const handleClick = () => {
    dashboard.actionClicked({
      action_type: 'schedule_appointment',
      source: 'dashboard_v2_card',
    });
    navigate('/schedule');
  };

  return (
    <FeatureCard
      title="Schedule an Appointment"
      icon={<CalendarIcon width={20} height={20} fill="currentColor" />}
      onClick={handleClick}
      fullHeight
      action={<Button>Schedule Appointment</Button>}
    >
      <CardImg src={publicAsset('/dashboard/home-tile_schedule-appointment.png')} alt="Schedule Appointment" />
    </FeatureCard>
  );
};

export default ScheduleAppointmentCard;
